import React from 'react';
import Loading from '@/pages/dashboard/components/Loading';
import rehypeRaw from 'rehype-raw';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import breaks from 'remark-breaks';
import './index.scss';
import classNames from 'classnames';

export const ChangeAnalysisAiSummarySection = (props) => {
  const { data, loading } = props;

  return (
    <div className={classNames("dbd-change-analysis-ai-content-header",{
      'dbd-change-analysis-ai-content-header--no-data': !loading && !data
    })}>
      {loading ? (
        <div className='dbd-change-analysis-ai-content-header-loading'>
          <Loading />
        </div>
      ) : data && (
        <ReactMarkdown
          className="dbd-change-analysis-ai-content-header-markdown"
          rehypePlugins={[rehypeRaw]}
          remarkPlugins={[gfm, breaks]}
        >
          {data}
        </ReactMarkdown>
      )}
    </div>
  );
};
